import React from 'react'
import { Grid } from '@mui/material'
import MyRideDetails from './MyRideDetails'
import Request from './RequestRide'

function RideDetails() {
  return (
    <Grid container justifyContent='space-around' 
    className='padding20'>
      <Grid item md={7} sm={12}>
        <MyRideDetails />
      </Grid>
      <Grid item md={3.2} sm={12}>
        <Request />
      </Grid>
    </Grid>
  )
}

export default RideDetails
